<template>
  <div class="layout-default flex flex-col">
    <LazyTheHeader data-containerid="page_header" hydrate-on-idle />
    <main class="content-wrap flex-1 px-100" data-containerid="page_content">
      <slot />
    </main>

    <div data-containerid="page_footer">
      <LazyTheFooter hydrate-on-idle />
      <TheBottomNavigation />
    </div>
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.layout-default {
  min-height: 100dvh;
  padding-bottom: $main-bottom-navigation-height;

  main {
    position: relative;
  }
}
</style>
